import React, { Component } from "react";

import AdminVideoCategories from "../VideoCategories/VideoCategories";

class AdminLearningVideoCategories extends Component {
  render() {
    return <AdminVideoCategories learning {...this.props} />;
  }
}

export default AdminLearningVideoCategories;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/LearningVideoCategories/LearningVideoCategories.js